import React from "react";
import "../styles/Contact.css";
import logoImage from "../img/logo.webp";

const ContactSection = () => {
  return (
    <div className=" contact-section section">
      <div className="heading-content">
        <h1 className="heading-secondary">Contactează-ne</h1>
        <p className="subheading">
          Nu ezitați să ne contactați. Suntem aici pentru a vă ajuta.
        </p>
      </div>
      <div className="contact-details">
        <img src={logoImage} alt="Logo" className="contact-logo" />
        <div className="details-text">
          <div className="location">
            <p className="location-text">
              Str. Petru Rareș 37, Chișinău, Moldova
            </p>
          </div>
          <div className="working-hours working-hours-contact">
            <p>Luni-Vineri: 8:30 - 20:00</p>
            <p>Sâmbătă: 9:00 - 19:00</p>
            <p>Duminică: 11:00 - 17:00</p>
          </div>
          <div className="contact-info">
            <p className="phone">Tel: +373 78 774 774</p>
            <p className="email">Email: order@gardeniaflowers.md</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
